import React, { useMemo } from 'react';
import BettingDistribution from './BettingDistribution';
import LeaderBoard from './LeaderBoard';
import { Race, TokenStats } from '../../../../types/race';

import './ParticipantSection.css';

type ParticipantSectionProps = {
  race: Race;
  tokensByPriceChange: TokenStats[];
};

const ParticipantSection = ({ race, tokensByPriceChange }: ParticipantSectionProps) => {
  const participants = useMemo(() => {
    // First, aggregate bets by bettor and token
    const betsMap = race.bets.reduce(
      (acc, bet) => {
        const bettorId = bet.bettor.id;
        const token = bet.token;
        const amount = bet.amount;
        const timestamp = bet.timestamp;

        if (token.id === tokensByPriceChange[0].token.id && amount !== 0n) {
          if (!acc[bettorId]) {
            acc[bettorId] = {
              [token.id]: {
                amount,
                lastTimestamp: timestamp,
              },
            };
          } else if (!acc[bettorId][token.id]) {
            acc[bettorId][token.id] = {
              amount,
              lastTimestamp: timestamp,
            };
          } else {
            acc[bettorId][token.id] = {
              amount: acc[bettorId][token.id].amount + amount,
              lastTimestamp: timestamp,
            };
          }
        }

        return acc;
      },
      {} as {
        [bettorId: string]: {
          [tokenId: string]: { amount: bigint; lastTimestamp: bigint };
        };
      }
    );

    return betsMap;
  }, [race.bets, tokensByPriceChange]);

  return (
    <div>
      <div className="divider mb-4 mt-8"></div>
      <div className="participant-section-header py-4">
        <div className="participant-section-title">
          <h3 className="font-bold">Staking Reward Multipliers</h3>
        </div>
      </div>

      <div className="participant-section-content">
        <BettingDistribution race={race} />
      </div>
      <div className="divider mb-8 mt-2"></div>
      <div className="participant-section-title mb-4">
        <h3 className="font-bold">Race Participants</h3>
        <span className="participant-count h-6">{race.totalParticipants.toString()} Active</span>
      </div>
      <div className="category-filters mb-6 flex">
        <button className={`category-button active flex-grow`}>Leaderboard</button>
      </div>
      <div className="participant-section-content">
        <LeaderBoard
          participants={participants}
          raceStatus={race.status}
          totalPool={race.totalPool}
          winningToken={tokensByPriceChange[0]}
          creatorFeePercent={race.creatorFeePercent}
        />
      </div>
    </div>
  );
};

export default ParticipantSection;
